import { MarketingOptInChannels, MarketingOptInPetType, MarketingOptInVariationKey } from './types';

export const getVariationKey = (
  petType: MarketingOptInPetType,
  channels: MarketingOptInChannels[]
): MarketingOptInVariationKey => {
  const hasEmail = channels?.includes('email') ?? false;
  const hasSms = channels?.includes('sms') ?? false;
  const hasWhatsapp = channels?.includes('whatsapp') ?? false;

  if (hasEmail && hasSms) {
    return petType === 'dog' ? 'dog_email_sms' : 'cat_email_sms';
  }

  if (hasEmail && hasWhatsapp) {
    return petType === 'dog' ? 'dog_email_whatsapp' : 'cat_email_whatsapp';
  }

  return petType === 'dog' ? 'dog_email' : 'cat_email';
};
